import { createContext, useContext } from 'react';
import type { OpsOverviewRoutes, OpsOverviewScope } from './types';

export interface OpsOverviewContextValue {
  scope: OpsOverviewScope;
  routes: OpsOverviewRoutes;
}

export const OpsOverviewContext = createContext<OpsOverviewContextValue | null>(null);

export const useOpsOverviewScope = (): OpsOverviewScope => {
  const ctx = useContext(OpsOverviewContext);
  if (!ctx) {
    throw new Error('useOpsOverviewScope requires OpsOverviewProvider');
  }
  return ctx.scope;
};

export const useOpsOverviewRoutes = (): OpsOverviewRoutes => {
  const ctx = useContext(OpsOverviewContext);
  if (!ctx) {
    throw new Error('useOpsOverviewRoutes requires OpsOverviewProvider');
  }
  return ctx.routes;
};
